import {
  IS_SAVING,
  DISABLE_LANGUAGE_SELECTOR,
  IS_BUTTONS_VISIBLE,
  SET_GEO_POL_DATA,
  SET_COUNTRY_STATE_MAPPING_DATA,
} from "../constants";

const INITIAL_STATE = {
  isSaving: false,
  disableLanguageSelector: false,
  isButtonVisible: true,
  geoPolData: {},
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case IS_SAVING: {
      return { ...state, isSaving: payload };
    }
    case DISABLE_LANGUAGE_SELECTOR: {
      return { ...state, disableLanguageSelector: payload };
    }
    case IS_BUTTONS_VISIBLE: {
      return { ...state, isButtonVisible: payload };
    }
    case SET_GEO_POL_DATA: {
      return { ...state, geoPolData: payload };
    }
    case SET_COUNTRY_STATE_MAPPING_DATA: {
      return { ...state, countryStateMappingData: payload };
    }
    default:
      return state;
  }
};
